module.exports = __webpack_public_path__ + "img/33-ABITO-MELODIA-U-COLORI-GARZA14.948bc6bf.jpg";